import React from "react";

const Button = ({label, theme, iconRight, typeIcon, action, disabled = false}) => {
  return (
    <div className={disabled ? `button-users__components__${theme} disabled`:`button-users__components__${theme}`} onClick={() => action()}>
      {label}
    </div>
  );
};

export default Button;
